export default __webpack_public_path__ + "devices-mobile.4a409a.png";